let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fJhA4")).then(() => parcelRequire('fsQkp'));